import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { labResultHistoryModalActions } from '../../../../redux/healthboard/patientPortal/lab-result-history-modal';
import { actions as labReslultHistoryAction } from '../../../../redux/healthboard/patientPortal/lab-result-history-req';
import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../../../redux/context/selectors';
import {
  selectLabResultHistoryData,
  selectLabResultHistoryError,
  selectTestResultComponentCode,
  selectTestResultComponentName,
  selectLabResultHistoryPending,
  selectOpenedLabResultHistoryModal,
} from '../../../../redux/healthboard/patientPortal/selectors';

const mapStateToProps = state => ({
  userId: loggedUserIdSelector(state),
  data: selectLabResultHistoryData(state),
  targetUserId: targetUserIdSelector(state),
  error: selectLabResultHistoryError(state),
  name: selectTestResultComponentName(state),
  pending: selectLabResultHistoryPending(state),
  componentCode: selectTestResultComponentCode(state),
  openedLabResultHistoryModal: selectOpenedLabResultHistoryModal(state),
});

const mapDispatchToProps = {
  close: labResultHistoryModalActions.close,
  getLabResultHistoryReq: labReslultHistoryAction.send,
  getLabResultHistoryClear: labReslultHistoryAction.clear,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/enhance.js